import React from "react";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import FilingForm from "../../../common/form/filing/FilingForm";

const RudiAdditionalDocStepFiling = () => {
  const rudiAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.RudiAdditionalDocForm;
  });

  return <FilingForm basePath={baseEndpointPaths.rudiAdditionalDoc} appId={rudiAdditionalDocForm.id} />;
};
export default RudiAdditionalDocStepFiling;
